import { createClassName } from 'utils/createClassName';

import './notificationPanelStyles.scss';

export const createNotificationPanelClassName = createClassName(
  'notificationPanel'
);
